module.exports = __webpack_public_path__ + "static/JoinCard-95bcd28419f967136c43263299c47f4a.png";